export function fetchWithCSRFToken(url: string, options: RequestInit) {
	const completeOptions = {
		...options,
		headers: {
			csrftoken: window.ocm.config.CSRFToken,
			...options.headers,
		},
	};

	// const responseData = await response.json(); das kann ja hier schon stattfinden.
	return fetch(url, completeOptions);
}
